const { Component } = Shopware;

Component.override('sw-cms-detail', {
    computed: {
        cmsPageTypes() {
            const cmsPageTypes = this.$super('cmsPageTypes');
            if (cmsPageTypes && !cmsPageTypes.cms_blog) {
                cmsPageTypes.cms_blog = this.$tc('acris-blogs.cms.pageTypeBlogLayout');
            }
            return cmsPageTypes;
        },

        cmsPageTypeSettings() {
            const blogMappingEntity = {
                cms_blog: {
                    entity: 'acris_blog',
                    mode: 'single'
                }
            }

            if (this.page.type === 'cms_blog') {
                return blogMappingEntity[this.page.type];
            }
            return this.$super('cmsPageTypeSettings');
        },
    }
});
